/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        if ($(window).width() > 769) {
          $('.navbar .dropdown').hover(function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

          }, function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

          });

          $('.navbar .dropdown > a').click(function() {
            console.log(this.href);

            if(! ( /#/.test(this.href) ) ) {
              location.href = this.href;              
            }
          });

        }

        /**
         * Lightbox for images, if image has attribute no-data-lightbox, lightbox will not initalized
         */
        $(function($) {
          $('.gallery').each(function(index, el) {
            var id = $(this).attr('id');
            $(this).find('.gallery-item').each(function(index, el) {
              $(el).find('a').attr('data-lightbox', id);
            });            
          });

          $("a[href$='.jpg'],a[href$='.png'],a[href$='.gif']").each(function(index) {
            if ($(this).attr('no-data-lightbox')) {
              // alert('dsaibled');
              // $(this).attr('data-lightbox', '');
              return false;
            }
            if (typeof($(this).attr('data-lightbox')) === 'undefined') {
              $(this).attr('data-lightbox', 'lightbox' + index);
            }
          });
        });

        lightbox.option({
          'albumLabel': 'Zdjęcie %1 z %2'
        });

        $('#menu-main-mobile-navigation').slicknav({
          prependTo: '.mobile-nav-container'
        });

        $('.menu-toggler').click(function(event) {
          $('#menu-main-mobile-navigation').slicknav('toggle');
          // $('.mobile-header-col .lang-switcher').toggle();
        });

        $('body').on('mouseenter mouseleave','.dropdown',function(e){
          var _d=$(e.target).closest('.dropdown');
          if (e.type === 'mouseenter') {
            _d.addClass('show');
          }
          setTimeout(function(){
            _d.toggleClass('show', _d.is(':hover'));
            $('[data-toggle="dropdown"]', _d).attr('aria-expanded',_d.is(':hover'));
          },100);
        });

        $('#lang-switcher').hover(function() {
          /* Stuff to do when the mouse enters the element */
          $('.dropdown').stop().fadeIn();
        }, function() {
          /* Stuff to do when the mouse leaves the element */
          $('.dropdown').stop().fadeOut();
        });

        var myLazyLoad = new LazyLoad({
            elements_selector: "img",
            threshold: 400
            // to_webp: true,
            // load_delay: 300
        });


        var $realizationsCarousel = $(".realizations-carousel");

        $realizationsCarousel.on('initialized.owl.carousel', function(e) {
          /* Act on the event */
          myLazyLoad.update();
        });

        $realizationsCarousel.owlCarousel({
          lazyload: true,
          items: 1,
          nav: true,
          dots: false,
          loop: true,
          // navText: ["<span class='posts-carousel-prev-icon'></span>", "<span class='posts-carousel-next-icon'></span>"],
          autoplay:false,
          autoplayTimeout: 5000,
          autoplayHoverPause:true,
          smartSpeed: 500,
          autoplaySpeed: 1000,
          responsiveClass:true,
          mouseDrag: true,
          margin: 30,
          stagePadding: 300,
          responsive : {
              // breakpoint from 0 up
              0 : {
                  items : 1

              },
              // breakpoint from 768 up
              768 : {
                  items : 1
              },
              992 : {
                  items : 1
              }
          }
        });

        $oferta_flipster = $("#realizations-carousel");

        var flipster_args =
        {
          style: 'flat',
          spacing: 0.025,
          vertical: true,
          scrollwheel: false,
          loop: true,
          center: true,
          touch: true
          // onItemSwitch: flipsterSwitched
        };

        $oferta_flipster.flipster(flipster_args);

        $(window).on('scroll resize', function(event) {
          if ( $oferta_flipster.visible( true ) ) {
            $oferta_flipster.trigger('resize.flipster');
            // myLazyLoad.update();
          }
        });

        $(window).on('load', function(event) {
          myLazyLoad.update();
        });

        $('.realization-carousel-container').on('click', '.realizations-prev', function(event) {
          event.preventDefault();
          /* Act on the event */
          $oferta_flipster.flipster('prev');
        });

        $('.realization-carousel-container').on('click', '.realizations-next', function(event) {
          event.preventDefault();
          /* Act on the event */
          $oferta_flipster.flipster('next');
        });

        function navMakeFixed() {
          // var body_top_margin = $('header.banner').outerHeight();

          // if( $('body').hasClass('home') ) {
          if( 1 ) {
            if ($(window).width() < 992 ) {
              $('.section-hero').css('padding-top', $('header.banner').outerHeight());
            } else {
            $('.section-hero').css('padding-top', '');
            }
          }

          if ($(this).scrollTop() >= $('header.banner').outerHeight()*0.5) {
            $('header.banner').addClass("nav-scrolled");

            if ($(window).width() < 992 ) {
              // $('.site').css('margin-top', $('header.banner').outerHeight());
            }
            if( !$('body').hasClass('home') ) {
            }
          } else {
            $('header.banner').removeClass("nav-scrolled");
            if ($(window).width() < 992 ) {
              // $('.site').css('margin-top', 0);
            }
            if( !$('body').hasClass('home') ) {
            }
          }
        }

        navMakeFixed();

        $(window).on('scroll resize', function(){
          // navMakeFixed();
        });

        $('#rules').on('change', function(event) {
          $('input[name="acceptance-rules"]').trigger('click');
        });

        $( "ol" ).each(function() {
          var   val=1;
            if ( $(this).attr("start")){
          val =  $(this).attr("start");
            }
          val=val-1;
         val= 'lis '+ val;
          $(this ).css('counter-increment',val );
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        var home_slider = $(".owl-slider");

        home_slider.on('initialized.owl.carousel', function(event){
          var current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
          var allItems = event.item.count;

          if (current > allItems) {
            current = current % allItems;
          }

          $('.slider-nav-number .current').text(current);
        });

        home_slider.owlCarousel({
          items: 1,
          nav: false,
          dots: true,
          loop: true,
          // navText: ["<span class='slider-prev-icon'></span>", "<span class='slider-next-icon'></span>"],
          autoplay:false,
          // autoplayTimeout: 5000,
          // autoplayHoverPause:true,
          // smartSpeed: 500,
          // autoplaySpeed: 1000,
          responsiveClass:true,
          mouseDrag: true,
          dotsContainer: '.slider-nav-container',
          autoHeight: false
        });

        home_slider.on('change.owl.carousel', function(event) {
          // console.log('dsadsa');
          $('.slide-content').removeClass('animated').removeClass('bounceInLeft');
          $('.slide-content__title').removeClass('animated').removeClass('bounceInLeft');
          // $('.slide-content__description').removeClass('animated').removeClass('bounceInLeft');
          $('.slide-content__button').removeClass('animated').removeClass('bounceInLeft');
        });

        home_slider.on('changed.owl.carousel', function(event) {
          setTimeout(function(){
            $('.active .slide-content').show().addClass('animated').addClass('bounceInLeft');
            $('.active .slide-content__title').show().addClass('animated').addClass('bounceInLeft');
            // $('.active .slide-content__description').show().addClass('animated').addClass('bounceInLeft');
            $('.active .slide-content__button').show().addClass('animated').addClass('bounceInLeft');
          }, 100);

          var current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
          var allItems = event.item.count;

          if (current > allItems || current <= 0) {
            current = current % allItems;
          }

          $('.slider-nav-number .current').text(current);
          $('.slider-nav-number .count').text(allItems);
        });

        $('.slider-nav-prev').on('click', function(event) {
          home_slider.trigger('prev.owl.carousel');
        });

        $('.slider-nav-next').on('click', function(event) {
          home_slider.trigger('next.owl.carousel');
        });

        $(window).load(function() {
          $('.owl-slider').trigger('refresh.owl.carousel');
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
